module.exports = __webpack_public_path__ + "../resources/img/Web_Image_Load.2ae82e3b.svg";